/* eslint-disable jsx-a11y/no-distracting-elements */
import "./postplayingtemplatesix.css";
import {
  React,
  Marquee,
  ReactPlayer,
} from "../../../Libraries/Post/PostPlaying/index";
import DOMPurify from 'dompurify';

const PostPlayingTemplateSix = (props) => {
  return (
    <div className="l6playing">
      {props.data.finalfile.txt_media_file_type === "Image" ? (
        <div className="mainarea">
          <img
            src={props.data.finalfile.txt_media_streaming_link}
            alt="img"
            height="100%"
            width="100%"
          />
        </div>
      ) : props?.data.finalfile.txt_media_file_type === "Video" ||
        props?.data?.finalfile?.txt_media_file_type === "Live" ? (
        <div className="mainarea">
          <ReactPlayer
            url={props.data.finalfile.txt_media_streaming_link}
            loop={true}
            playing={true}
            playsInline
            controls
            width="100%"
          />
        </div>
      ) : props?.data?.finalfile?.txt_media_file_type === "Widget" ? (
        <div className="mainarea">

        {/* <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(props?.data?.finalfile?.txt_media_streaming_link),
          }}
          style={{ height: "100%" }}
        /> */}
        <p>{props?.data?.finalfile?.txt_media_streaming_link}</p>
        </div>
      ) : null}
      <div className="sidebararea">
        <div className="sidebarmarqueewrapper">
          <marquee direction="up" style={{ height: "100%" }}>
            {props?.data?.sidebar.map((sidebarcontent, index) => (
              <div key={index}>
                <div className="row flex-column justify-content-center p-3 marquee">
                  <div className="col fs-1">
                    {sidebarcontent.txt_sidebar_title}
                  </div>
                  <div className="col">
                    {sidebarcontent.txt_sidebar_description}
                  </div>
                </div>
              </div>
            ))}
          </marquee>
        </div>
      </div>
      <div className="footerarea">
        <Marquee style={{ height: "100%", minHeight: 70 }} gradient={false}>
          {props?.data?.footer.map((footerdes, index) => (
            <div key={index} className="mr-5">
              {footerdes.txt_footer_description}
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default PostPlayingTemplateSix;
